import { MapInitialInteractor, MapInitialDrawSaveRequest, PointRemoveRequest, PointsToPDF } from "../../Coordinator/MapInitial/MapInitialInteractor";
import { Image360, Shape } from "./MapInitialViewController";

export class MapInitialViewModel {
    private interactor: MapInitialInteractor;

    constructor() {
        this.interactor = new MapInitialInteractor();
    }

    public fetchSaveDraw(obj: Array<Shape>): PromiseLike<any> {
        var arrayResult = Array<MapInitialDrawSaveRequest>()
        for (var i = 0; i < obj.length; i++) {
            var item = new MapInitialDrawSaveRequest(obj[i].type, obj[i].geojson, obj[i].sshape, obj[i].scamada)
            arrayResult.push(item)
        }

        return new Promise((res, rej) => {
            this.interactor.fetchSaveDraw(arrayResult).then((result) => {
                return res(result)
            }, e => {
                return rej(e)
            });
        })
    }

    public fetchRemovePoint(obj: any): PromiseLike<any> {
        var request = new PointRemoveRequest(
            obj['sshape'] ? parseInt(obj['sshape']) : 0
        )

        return new Promise((res, rej) => {
            this.interactor.fetchRemovePoint(request).then((result) => {
                return res(result)
            }, e => {
                return rej(e)
            });
        })
    }

    public fetchMapPDF(sshape: number[]): PromiseLike<any> {
        var request = new PointsToPDF(sshape)
        return new Promise((res, rej) => {
            this.interactor.fetchMapPDF(request).then((result) => {
                return res(result)
            }, e => {
                return rej(e)
            });
        })
    }

    public fetchCutFeature(featureObj: any): PromiseLike<any> {
        return new Promise((res, rej) => {
            this.interactor.fetchCutFeature(featureObj).then((result) => {
                return res(result)
            }, e => {
                return rej(e)
            });
        })
    }

    public fetchDuplicateFeature(shape: any): PromiseLike<any> {
        return new Promise((res, rej) => {
            this.interactor.fetchDuplicateFeature(shape).then((result) => {
                return res(result)
            }, e => {
                return rej(e)
            });
        })
    }

    public fetchRotateFeature(rotatedFeature: any): PromiseLike<any> {
        return new Promise((res, rej) => {
            this.interactor.fetchRotateFeature(rotatedFeature).then((result) => {
                return res(result)
            }, e => {
                return rej(e)
            });
        })
    }
    public tabularDescriptiveMemorialRelatory(layers: Number[], sshape: number, selectedProfissional: number): PromiseLike<any> {
        return new Promise((res, rej) => {
            this.interactor.tabularDescriptiveMemorialRelatory(layers, sshape, selectedProfissional).then((result) => {
                return res(result)
            }, e => {
                return rej(e)
            });
        })
    }
    public textualDescriptiveMemorialRelatory(layers: Number[], sshape: number, selectedProfissional: number): PromiseLike<any> {
        return new Promise((res, rej) => {
            this.interactor.textualDescriptiveMemorialRelatory(layers, sshape, selectedProfissional).then((result) => {
                return res(result)
            }, e => {
                return rej(e)
            });
        })
    }
    public fetchProfessional(): PromiseLike<any> {
        return new Promise((res, rej) => {
            this.interactor.fetchProfessional().then((result) => {
                return res(result)
            }, e => {
                return rej(e)
            });
        })
    }

    public fetchImage360Navigate(clickedImage: Image360, oldImg: number): PromiseLike<any> {
        return new Promise((res, rej) => {
            this.interactor.fetchImage360Navigate(clickedImage, oldImg).then((result) => {
                return res(result)
            }, e => {
                return rej(e)
            });
        })
    }

      public checkPointData(sshape:number): PromiseLike<any> {
        return new Promise((res, rej) => {
            this.interactor.checkPointData(sshape).then((result) => {
                return res(result)
            }, e => {
                return rej(e)
            });
        })
    }

      public checkShapeData(sshape:number): PromiseLike<any> {
        return new Promise((res, rej) => {
            this.interactor.checkShapeData(sshape).then((result) => {
                return res(result)
            }, e => {
                return rej(e)
            });
        })
    }
    
}